import { render, staticRenderFns } from "./editor_template_data_properties.vue?vue&type=template&id=32dc2f6f&scoped=true"
import script from "./editor_template_data_properties.vue?vue&type=script&lang=js"
export * from "./editor_template_data_properties.vue?vue&type=script&lang=js"
import style0 from "./editor_template_data_properties.vue?vue&type=style&index=0&id=32dc2f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc2f6f",
  null
  
)

export default component.exports